import {
  upgradePackageShelvesStageValidatorPhone,
  upgradePackageShelvesStageVerificationCode,
} from '@/services/remoteUpgrade';

export default {
  namespace: 'RemoteUpgrade_shelvesStageValidate',

  state: {
    data: {},
    code: {},
  },

  effects: {
    *validatorPhone({ payload }, { call, put, select }) {
      const old = yield select(
        state => state.RemoteUpgrade_shelvesStageValidate.data
      );

      if (Object.keys(old).length > 0) {
        return;
      }

      const { status, data } = yield call(
        upgradePackageShelvesStageValidatorPhone,
        payload
      );

      if (status === 200) {
        yield put({
          type: 'save',
          payload: data,
        });
      }
    },

    *sendValidatorCode({ payload, callback }, { call, put }) {
      const { status, data } = yield call(
        upgradePackageShelvesStageVerificationCode,
        payload
      );

      if (status === 201) {
        yield put({
          type: 'saveCode',
          payload: data,
        });
      }

      callback();
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        data: payload,
      };
    },

    saveCode(state, { payload }) {
      return {
        ...state,
        code: payload,
      };
    },
  },
};
